module.exports = __webpack_public_path__ + "static/Bullpen Logo-7ca1d3acba49644aaac46fcb5f98a0ae.png";